/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyAuditItem from './pharmacy-audit-item';
import PharmacyAuditItemDetail from './pharmacy-audit-item-detail';
import PharmacyAuditItemUpdate from './pharmacy-audit-item-update';
import PharmacyAuditItemDeleteDialog from './pharmacy-audit-item-delete-dialog';

const PharmacyAuditItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyAuditItem />} />
    <Route path="new" element={<PharmacyAuditItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyAuditItemDetail />} />
      <Route path="edit" element={<PharmacyAuditItemUpdate />} />
      <Route path="delete" element={<PharmacyAuditItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyAuditItemRoutes;
